import{e as m,m as u}from"./chunk-HBP5N4FR.js";var f,n=m(()=>{u();f=({accountNonce:r,transactionNonce:e})=>e&&e>r?e:r});export{f as a,n as b};
//# sourceMappingURL=chunk-U62W3J3X.js.map
